import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Functions, httpsCallable } from '@angular/fire/functions';

declare var Plaid: any;

@Component({
  selector: 'app-bank-management',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bank-management.component.html',
  styleUrls: ['./bank-management.component.scss']
})
export class BankManagementComponent implements OnInit {
  private functions = inject(Functions);

  isLoading = false;
  isLoadingAccounts = false;
  plaidHandler: any;
  accounts: any[] = [];

  ngOnInit() {
    this.loadPlaidScript();
    this.fetchConnectedAccounts();
  }

  loadPlaidScript() {
    const script = document.createElement('script');
    script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
    document.body.appendChild(script);
  }

  async connectBank() {
    this.isLoading = true;
    try {
      // 1. Fetch `link_token` from your Firebase backend
      const createTokenFn = httpsCallable(this.functions, 'createPlaidLinkToken');
      const response: any = await createTokenFn();
      const linkToken = response.data.link_token; 

      // 2. Initialize Plaid Link
      this.plaidHandler = Plaid.create({
        token: linkToken,
        onSuccess: (public_token: string, metadata: any) => {
          console.log('Public Token:', public_token);
          console.log('Metadata:', metadata);
          this.exchangePublicToken(public_token);
        },
        onLoad: () => {
          this.plaidHandler.open();
        },
        onExit: (err: any, metadata: any) => {
          console.log('User exited Plaid Link:', err, metadata);
        }
      });
    } catch (error) {
      console.error('Error connecting to Plaid:', error);
    } finally {
      this.isLoading = false;
    }
  }

  async exchangePublicToken(publicToken: string) {
    this.isLoading = true;
    try {
      const exchangeFn = httpsCallable(this.functions, 'exchangePlaidPublicToken');
      await exchangeFn({ publicToken });
      alert('Bank connected successfully!');
      await this.fetchConnectedAccounts();
    } catch (error) {
      console.error('Error exchanging Plaid token:', error);
      alert('Failed to connect bank.');
    } finally {
      this.isLoading = false;
    }
  }

  async fetchConnectedAccounts() {
    this.isLoadingAccounts = true;
    try {
      const getAccountsFn = httpsCallable(this.functions, 'getPlaidAccounts');
      const response: any = await getAccountsFn();
      this.accounts = response.data.accounts || [];
    } catch (error) {
      console.error('Error fetching accounts:', error);
    } finally {
      this.isLoadingAccounts = false;
    }
  }

  getStatements(accountId: string) {
    alert(`Fetching statements/transactions for account ${accountId} will be implemented here.`);
  }
}
